<template>
    <div>
        <h1>Prenotazioni in Attesa di Conferma</h1>
        <div v-for="r in $store.state.incompleteReservations" :key="r.id">
            <span>{{r.reservationNumber}} &bull;&nbsp;</span>
            <span>{{format(r.reservationDate)}}</span>
            <template v-if="r.status === 'awaiting_customer_confirmation'">
                <button @click="accept(r.id)">Accetta</button>
                <button @click="accept(r.id)">Rifiuta</button>
                <button @click="idForm = r.id">Altra Data</button>
                <template v-if="idForm == r.id">
                    <date-picker v-model="date" is-inline :min-date="new Date()"/>
                    <input type="time" v-model="time">
                    <button @click="setDate(r.id)">Salva</button>
                    <button @click="idForm = null">Annulla</button>
                </template>
            </template>
            <span v-else><br>In Attesa di Conferma</span>
        </div>
        <h1>Prenotazioni Confermate</h1>
        <div v-for="r in $store.state.upcomingReservations" :key="r.id">
            <span>{{format(r.reservationDate)}}</span>
        </div>
    </div>
</template>

<script>
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
import formatISO from 'date-fns/formatISO'
import format from 'date-fns/format'
import it from 'date-fns/locale/it'
export default {
    methods: {
        format(date){
            return format(new Date(date),"dd MMMM yyyy - HH:mm",{locale:it});
        },
        accept(id){
            this.$store.dispatch('setReservationStatus',{id,status: 'confirmed'});
        },
        refuse(id){
            this.$store.dispatch('setReservationStatus',{id,status: 'refused'});
        },
        setDate(id){
            let date = this.date;
            date.setHours(this.time.split(":")[0],this.time.split(":")[1]);
            this.$store.dispatch('setReservationStatus',{id,reservationDate: formatISO(date)});
            this.idForm = null;
        }
    },
   async created(){
        console.log(this.$route.params);
        if(this.$route.params.actionToken){
            await this.$store.dispatch("loginWithActionToken",this.$route.params.actionToken);
            this.$router.replace("/reservation");
        } 
        this.$store.dispatch("getIncompleteReservations")
        this.$store.dispatch("getUpcomingReservations")
    },
    data(){
        return {
            date: null,
            time: null,
            idForm:null
        }
    },
    components: {
        DatePicker
    }
}
</script>